import { type AliasToken } from 'antd/es/theme/interface';

import type { BrandConfig } from '../config/branding/branding.types';
import {
  useBrand,
  useBrandTheme,
  useBrandingContext,
  usePageTitle,
} from '../contexts/BrandingContext';

/**
 * Main hook for accessing branding configuration
 * This is now a wrapper around the BrandingContext
 *
 * @returns The theme tokens for the current brand
 */
export const useBranding = (): Partial<AliasToken> => {
  const theme = useBrandTheme();
  return theme;
};

// Re-export the context hooks for convenience
export { useBrandingContext, useBrand, useBrandTheme, usePageTitle };

// Export type for use in components
export type { BrandConfig };
